<template>
	<!-- 订单被驳回弹框 -->
	<common-modal :showClose="true" @close-modal="onCloseModalClick">
	    <div class="modal">
	        <div class="title">请选择驳回理由</div>
	        <ul class="list-wrap">
	            <li>
	                <span class="select-mark" @click="selectFlag=0" :class='selectFlag==0?"done":"undone"'></span>
	                <span class="modal-text">未解决问题</span>
	            </li>
				
				<li>
				    <span class="select-mark" @click="selectFlag=1" :class='selectFlag==1?"done":"undone"'></span>
				    <span class="modal-text">其它原因</span>
				</li>
				
				<li v-if="selectFlag==1">
					<textarea class="textarea" :rows="8" v-model="otherReason" @blur="backHeight"/>
				</li>
	        </ul>
	        <div class="modal-submit" @click="clickReject(selectFlag,otherReason)">确定</div>
	    </div>
	</common-modal>
</template>

<script>
	import CommonModal from './CommonModal';
    export default {
        data(){
            return{
				otherReason:"",
				selectFlag:0
            }
        },
		
        methods:{
			clickReject(selectFlag,otherReason){
				this.$emit("clickReject",selectFlag,otherReason)
			},
			onCloseModalClick(){
				this.$emit("close-modal")
			},
			backHeight(){
			    setTimeout(() => {
			        const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
			        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
			    }, 100);
			}
        },
		components:{
			CommonModal
		}
        
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{font-family:PingFangSC-Regular;font-weight:400;background:#FFF}
	.modal{width: 320px;background: #fff;margin: 0 auto;padding-bottom: 20px;}
	.title{padding: 12px 20px 0 20px;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;}

	/* 驳回订单弹框 */
	.list-wrap{padding: 18px 21px 25px 21px;}
	.list-wrap li{margin-bottom: 10px}
	.select-mark{display: inline-block;width:17px;height:17px;border-radius: 50%;margin-right: 7px;vertical-align: top;margin-top: 4px}
	.modal-text{display: inline-block;width: 243px;font-size:15px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);vertical-align: top;}
	.textarea{width: 278px;height: 105px;padding: 10px;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(207,207,207,1);resize: none;outline: none}
	.done{background: url(../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.undone{background: url(../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
	.modal-submit{width:278px;height:40px;margin: 0 auto;line-height:40px;border-radius:2px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;background:rgba(65,132,244,1);text-align: center;color:rgba(255,255,255,1);}
</style>
